//Paquetes NPM de GYF. 
import { Engine1Proxy, RestApiProxy, RabbitListener, SagasProxy, ConciergeProxy, SagasHelper } from 'com-gyf-webcore-servicehub';
import { LogHelper } from 'com-gyf-webcore-loghelper';
import TransaccionManager from '../../../Common/Managers/TransaccionManager';
import GlobalHelper from '../../../Common/Helpers/GlobalHelper';

//Seteo de apiUrl
RestApiProxy.SetApiUrl();

export const ACTUALIZAR_FECHA_SALDOS_MOV = "ACTUALIZAR_FECHA_SALDOS_MOV";
export const ACTUALIZAR_SALDOS_PARA_MOSTRAR = "ACTUALIZAR_SALDOS_PARA_MOSTRAR";
export const FOMARTO_FECHA_SALDOS = "FOMARTO_FECHA_SALDOS";
export const ACTUALIZA_FECHA = "ACTUALIZA_FECHA";
export const OCULTAR_MODAL = "OCULTAR_MODAL";
export const MOVIMIENTO_RANGO_DIAS = "MOVIMIENTO_RANGO_DIAS";
export const REINICIAR_FECHAS = "REINICIAR_FECHAS";
export const GET_SALDOS_MOVIMIENTOS_BUSQUEDA = "GET_SALDOS_MOVIMIENTOS_BUSQUEDA";
export const ACTUALIZAR_SALDOS_PARA_MOSTRAR_BUSQUEDA = "ACTUALIZAR_SALDOS_PARA_MOSTRAR_BUSQUEDA";
export const LOADING = "LOADING";
export const MOSTRAR_CALENDARIOS = "MOSTRAR_CALENDARIOS";
export const OCULTAR_MODAL_ADVERTENCIA = "OCULTAR_MODAL_ADVERTENCIA";
export const CAMBIAR_MES = "CAMBIAR_MES";
export const SELECCIONAR_RADIO = "SELECCIONAR_RADIO";


let _dispatch;

export function getMayorId(a, b) {
    const idA = a.id ? a.id : a.ID;
    const idB = b.id ? b.id : b.ID;

    let IDMayor = 0;
    if (idA > idB) {
        IDMayor = -1;
    } else if (idA < idB) {
        IDMayor = 1;
    }
    return IDMayor;
}

export function actualizarSaldosParaMostrar() {

    return (dispatch, getState) => {
        LogHelper.In(actualizarSaldosParaMostrar.name);

        _dispatch = dispatch;
        let state = getState().DatosCuenta.SaldosMovimientos;

        if (state.BusquedaMovimientos)
            _dispatch({ type: ACTUALIZAR_SALDOS_PARA_MOSTRAR_BUSQUEDA });
        else
            _dispatch({ type: ACTUALIZAR_SALDOS_PARA_MOSTRAR });

    }
}

function convertirFechaFormato_MM_YYYY(fecha) {
    if (typeof (fecha) == "string" && fecha.includes("/")) {
        let fechaAux = fecha.split('/');
        let fechaFinal;
        let mes = fechaAux[0].length > 1 ? fechaAux[0] : "0" + fechaAux[0];
        fechaFinal = fechaAux[1] + "/" + mes;

        return new Date(fechaFinal);
    } else {
        return fecha;
    }
}

function obtenerFechaFormatoString(fecha) {
    let mesActual, fechaFinal;

    if (typeof (fecha) == "object") {
        mesActual = fecha.getMonth() + 1;
        fechaFinal = (mesActual > 9 ? mesActual : '0' + mesActual) + '/' + fecha.getFullYear();
    } else if (fecha == "Invalid Date") {
        mesActual = new Date().getMonth() + 1;
        fechaFinal = (mesActual > 9 ? mesActual : '0' + mesActual) + '/' + new Date().getFullYear();
    }

    return fechaFinal;
}

export function cambiarMesPorFlecha(sentido) {
    LogHelper.In(cambiarMesPorFlecha.name, sentido);

    return (dispatch, getState) => {
        let state = getState();
        let fechaActual = state.DatosCuenta.SaldosMovimientos.fecha;
        let fechaAux, mesAux, anioAux, fechaMinimaPermitida, fechaPosterior;


        if (typeof fechaActual == 'string') {
            fechaPosterior = validarFechaPosterior(fechaActual);
            fechaMinimaPermitida = validarMinimoPermitidoFecha(fechaActual);
        }
        else {
            fechaActual = obtenerFechaFormatoString(fechaActual);
            fechaPosterior = validarFechaPosterior(fechaActual);
            fechaMinimaPermitida = validarMinimoPermitidoFecha(fechaActual);
        }

        if (!fechaMinimaPermitida && !fechaPosterior) {
            //se convierte la fecha a Obj para sumar o restar un mes
            if (typeof fechaActual == 'string') fechaActual = convertirFechaFormato_MM_YYYY(fechaActual);

            if (sentido == 'anterior') {
                mesAux = fechaActual.getMonth() + 1;
                anioAux = fechaActual.getFullYear();

                //Solo se puede retroceder hasta el 04/2020
                if (mesAux == 4 && anioAux == 2020)
                    fechaActual = obtenerFechaFormatoString(fechaActual);
                else {
                    fechaActual = new Date(fechaActual.setMonth(fechaActual.getMonth() - 1));
                    fechaActual = obtenerFechaFormatoString(fechaActual);
                    dispatch({ type: FOMARTO_FECHA_SALDOS, valor: true, mostrarModalSaldos: false });
                }
            } else {
                fechaAux = new Date(fechaActual.setMonth(fechaActual.getMonth() + 1));
                fechaAux = obtenerFechaFormatoString(fechaAux);

                if (validarFechaPosterior(fechaAux)){ 
                    fechaAux = new Date(fechaActual.setMonth(fechaActual.getMonth() - 1));
                    fechaActual = obtenerFechaFormatoString(fechaAux);
                }
                else {
                    fechaActual = fechaAux;
                    dispatch({ type: FOMARTO_FECHA_SALDOS, valor: true, mostrarModalSaldos: false });
                }
            }

            dispatch({ type: CAMBIAR_MES, fecha: fechaActual });

        } else if (fechaPosterior) {
            let mesActual = new Date().getMonth() + 1;
            let fechaFinal = (mesActual > 9 ? mesActual : '0' + mesActual) + '/' + new Date().getFullYear();
            
            dispatch({ type: FOMARTO_FECHA_SALDOS, valor: true, mostrarModalSaldos: false });
            dispatch({ type: CAMBIAR_MES, fecha: fechaFinal });
        } else {
            dispatch({ type: FOMARTO_FECHA_SALDOS, valor: true, mostrarModalSaldos: false });
            dispatch({ type: CAMBIAR_MES, fecha: "04/2020" });
        }
    }
}

export function validarFormatoFecha(fecha, formatoOk) {
    LogHelper.In(validarFormatoFecha.name, fecha);
    return (dispatch, getState) => {
        if (!formatoOk || validarFechaPosterior(fecha) || validarMinimoPermitidoFecha(fecha)) {
            dispatch({ type: ACTUALIZA_FECHA, valor: fecha });
            dispatch({ type: FOMARTO_FECHA_SALDOS, valor: false, mostrarModalSaldos: false });
        }
        else {
            dispatch({ type: FOMARTO_FECHA_SALDOS, valor: true, mostrarModalSaldos: false });
            dispatch({ type: ACTUALIZA_FECHA, valor: fecha });
        }
    }
}

export function buscarMovimientos(fecha) {
    LogHelper.In(buscarMovimientos.name, fecha);

    return (dispatch, getState) => {
        let stateSaldos = getState().DatosCuenta.SaldosMovimientos;
        let stateTarjetas = getState().tarjetas;
        _dispatch = dispatch;

        if (stateSaldos.fechaSaldosFormatoOk) {
            dispatch({ type: LOADING, valor: true });

            let paramCuentaTarjeta = {
                ID_CUENTATARJETA: stateTarjetas.cuentaCorriente.CuentaTarjetaId,
                PERIODO: fecha,
                TIPO_SALDO: stateSaldos.radioBtnSaldos
            };

            Engine1Proxy.AddDataSourcesRequests(paramCuentaTarjeta, 'SP_GET_SALDOS_MOVIMIENTOS', 'Get', 'Tarjetas', 'PARAMETRIA', null, 'User', true, 'ObtenerMovimientosAdintar');
            Engine1Proxy.Execute((data) => _callBackGetScreenData(data), null, null, "CONSULTASOCIOS");
        } else {
            dispatch({ type: FOMARTO_FECHA_SALDOS, mostrarModalSaldos: true, valor: false });
        }
    }
}

function _callBackGetScreenData(data) {

    var SaldosMov = {
        Saldos: JSON.parse(data.ObtenerMovimientosAdintar).Recordset0.Rows
    }

    SaldosMov.Saldos.sort(getMayorId);
    _dispatch({ type: LOADING, valor: false });
    _dispatch({ type: GET_SALDOS_MOVIMIENTOS_BUSQUEDA, SaldosMov });
}

export function ocultarModal() {
    return (dispatch, getState) => {
        dispatch({ type: OCULTAR_MODAL });
    }
}

export function ocultarModalAdvertencia() {
    return (dispatch, getState) => {
        dispatch({ type: OCULTAR_MODAL_ADVERTENCIA });
    }
}

export function limpiarMovimientos() {
    return (dispatch, getState) => {
        dispatch({ type: LOADING, valor: true });
        dispatch({ type: MOSTRAR_CALENDARIOS, valor: false });
        dispatch({ type: REINICIAR_FECHAS });
    }
}

export function mostrarCalendario() {
    return (dispatch, getState) => {
        dispatch({ type: MOSTRAR_CALENDARIOS, valor: true });
        dispatch({ type: LOADING, valor: false });
    }
}

export function selectRadio(id) {
    return (dispatch, getState) => {
        dispatch({ type: SELECCIONAR_RADIO, valor: id });
    }
}

//Funciones Auxiliares 

function validarRangoDeDias(fechaDesde, fechaHasta) {
    let fechaDesdeFinal, fechaHastaFinal, fechaDesdeAux, fechaHastaAux, diasDiferencia
    let moment = require('moment');

    if (typeof fechaDesde == "object") {
        fechaDesdeAux = fechaDesdeAux.toLocaleDateString();
        fechaDesdeAux = fechaDesdeAux.length == 9 ? "0" + fechaDesdeAux : fechaDesdeAux;
    } else {
        fechaDesdeAux = fechaDesde;
    }

    if (typeof fechaHasta == "object") {
        fechaHastaAux = fechaHastaAux.toLocaleDateString();
        fechaHastaAux = fechaHastaAux.length == 9 ? "0" + fechaHastaAux : fechaHastaAux;
    } else {
        fechaHastaAux = fechaHasta;
    }

    fechaDesdeAux = fechaDesdeAux.split("/");
    fechaDesdeFinal = moment(fechaDesdeAux[2] + "-" + fechaDesdeAux[1] + "-" + fechaDesdeAux[0]);

    fechaHastaAux = fechaHastaAux.split("/");
    fechaHastaFinal = moment(fechaHastaAux[2] + "-" + fechaHastaAux[1] + "-" + fechaHastaAux[0]);

    diasDiferencia = fechaHastaFinal.diff(fechaDesdeFinal, 'days');

    if (diasDiferencia > 90)
        return true
    else
        return false
}

function validarFechasMovimiento(fechaDesde, fechaHasta) {
    let fechaDesdeFinal, fechaHastaFinal, fechaDesdeAux, fechaHastaAux, fechaPosterior

    if (typeof fechaDesde == "object") {
        fechaDesdeAux = fechaDesdeAux.toLocaleDateString();
        fechaDesdeAux = fechaDesdeAux.length == 9 ? "0" + fechaDesdeAux : fechaDesdeAux;
    } else {
        fechaDesdeAux = fechaDesde;
    }

    if (typeof fechaHasta == "object") {
        fechaHastaAux = fechaHastaAux.toLocaleDateString();
        fechaHastaAux = fechaHastaAux.length == 9 ? "0" + fechaHastaAux : fechaHastaAux;
    } else {
        fechaHastaAux = fechaHasta;
    }

    fechaDesdeAux = fechaDesdeAux.split("/");
    let dia = fechaDesdeAux[0];
    let mes = fechaDesdeAux[1];
    let anio = fechaDesdeAux[2];
    fechaDesdeAux = mes + "/" + dia + "/" + anio;
    fechaDesdeFinal = new Date(fechaDesdeAux);

    fechaHastaAux = fechaHastaAux.split("/");
    dia = fechaHastaAux[0];
    mes = fechaHastaAux[1];
    anio = fechaHastaAux[2];
    fechaHastaAux = mes + "/" + dia + "/" + anio;
    fechaHastaFinal = new Date(fechaHastaAux);

    if (fechaDesdeFinal > fechaHastaFinal)
        fechaPosterior = true;
    else
        fechaPosterior = false;

    return fechaPosterior;
}

function validarMinimoPermitidoFecha(fecha) {
    let fechaAux = fecha.split("/");
    let fechaFinal, fechaMinima, fechaMinimaSuperada, mes, anio;

    mes = fechaAux[0];
    anio = fechaAux[1];
    fechaAux = mes + "/" + "01" + "/" + anio;
    fechaFinal = new Date(fechaAux);
    fechaMinima = new Date("04/01/2020");

    if ((fechaFinal < fechaMinima) || (fechaFinal == "Invalid Date"))
        fechaMinimaSuperada = true;
    else
        fechaMinimaSuperada = false;

    return fechaMinimaSuperada;
}

function validarFechaPosterior(fecha) {
    let fechaAux = fecha.split("/");
    let fechaFinal;
    let fechaPosterior;

    let dia = "01";
    let mes = fechaAux[0];
    let anio = fechaAux[1];
    fechaAux = mes + "/" + dia + "/" + anio;

    fechaFinal = new Date(fechaAux);

    if ((fechaFinal > new Date())  || (fechaFinal == "Invalid Date"))
        fechaPosterior = true;
    else
        fechaPosterior = false;

    return fechaPosterior;
}